import React from 'react';
import emptyLightImage from '../../../assets/images/empty-light2.png';

const ContentEmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center">
      <img
        src={emptyLightImage}
        alt="风险预警与纠偏方案智能化推荐"
        className="h-[88px] w-[88px] object-contain"
      />
      <div className="mt-3 text-[14px] leading-6 text-[#6b7280]">
        风险预警与纠偏方案智能化推荐
      </div>
    </div>
  );
};

export default ContentEmptyState;
